import styled from "styled-components";

export default styled.div`
  padding: ${(props) => props.padding || "10px 20px"};
  margin: ${(props) => props.margin || "initial"};
`;
